import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../services/auth/auth.service';
import { HttpUtil } from './http-util';
import { HttpRequestOption, HttpRequestBody } from '../interface/http-request';
import { API_URLS } from '../constants/api_url-util';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HttpRequestService {

    //   private base_api_url = window['base_api_url'];
    // private base_api_url = 'https://merchantapi.polysports.com/api/v1/';
    private base_api_url = environment.apiUrl;
    // private base_api_url = 'http://api.wahfood.pk:3222/';

    constructor(private http: HttpClient,
        private authService: AuthService) { }

    private async request(options: HttpRequestOption, log: string, error: string, method: string) {
        let url: string = options.url ? options.url : this.base_api_url;


        const queryParams: string = options.queryParams ? `?${options.queryParams}` : '';
       

        const params: string = options.params ? `${options.params}` : '';
        if (params) {
            url = `${url}${API_URLS[options.endpoint as keyof typeof API_URLS]}${params}`;
        } else {
            //  url = `${url}${APIUrlsUtil.apisJsonObj[options.endpoint]}${queryParams}`;
            url = `${url}${API_URLS[options.endpoint as keyof typeof API_URLS]}${queryParams}`;

            
        }
        const hu = new HttpUtil(this.http, this.authService, method);
        return await hu.callHttp(url, '', options, log, error, options.header);
    }

    getAddressFromLatLng(lat: number, lng: number): Observable<any> {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBfEqSPkHCCLfcUzaQEw5ejxR_FWU6RUJw&sensor=true`;
      
        return this.http.get<any>(url);
    }
    async callHttp(request: HttpRequestBody) {
        return await this.request(request.option, request.log, request.error, request.method);
    }
}
